import { Component, Input, OnInit } from "@angular/core";
import { faDatabase, faIdCard, faMoneyBills, faSearch, faSimCard } from "@fortawesome/free-solid-svg-icons";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { catchError } from "rxjs/operators";
import { AppToastService } from "src/app/components/toasts/app-toast.service";
import { HttpReportDayEndService } from "src/app/modules/kiosk/http-report-day-end.service";
import { AuditDataDto, AuditDataDtoWithGroup, ReportDayEndDto } from "src/app/modules/kiosk/dto";
import { UtilService } from "src/app/modules/kiosk/util.service";
import { HttpKioskAuditsService } from "src/app/modules/kiosk/http-kiosk-audits.service";

@Component({
	selector: 'app-kiosk-audits-table-data',
	templateUrl: './kiosk-audits-table-data.component.html',
	styleUrls: ['./kiosk-audits-table-data.component.scss']
})
export class KioskAuditTableDataComponent {

	@Input() audits: AuditDataDtoWithGroup[];

	util = UtilService;

	view = faSearch;

	constructor(
		private modalService: NgbModal,
		private httpService: HttpKioskAuditsService,
		private spinner: NgxSpinnerService,
		private toastService: AppToastService,) { }

	@Input()
	set payload(payload: AuditDataDtoWithGroup[]) {
		if (!payload) {
			return;
		}

		this.audits = payload;

		var txIds = this.getOneRowPerDuplicateTxId();

		txIds.forEach(audit => {
			var row = this.audits.find(item => item.txId === audit.txId);
			row.addToRow = true;
		});

		console.log('Payload:', this.audits);
		
	}

	getRowCount(txId: string): number {
		return this.audits.filter(item => item.txId === txId).length;
	}

	getOneRowPerDuplicateTxId(): AuditDataDto[] {
		const countMap = new Map<string, number>();
		const seen = new Set<string>();
		const result: AuditDataDto[] = [];

		// Count occurrences of each txId
		for (const row of this.audits) {
			const txId = row.txId;
			countMap.set(txId, (countMap.get(txId) || 0) + 1);
		}

		// Keep only the first row for each duplicated txId
		for (const row of this.audits) {
			const txId = row.txId;
			if (countMap.get(txId)! > 1 && !seen.has(txId)) {
				result.push(row);
				seen.add(txId);
			}
		}

		return result;
	}
}